export type OptionField = {
  key: string;
  label: string;
  options: { value: string; label: string }[];
};

export const TOOL_OPTIONS: Record<string, OptionField[]> = {
  'ad-creative': [
    {
      key: 'language',
      label: 'Language',
      options: [
        { value: 'english', label: 'English' },
        { value: 'spanish', label: 'Spanish' },
        { value: 'portuguese', label: 'Portuguese' },
        { value: 'french', label: 'French' },
        { value: 'german', label: 'German' },
        { value: 'italian', label: 'Italian' },
      ],
    },
    {
      key: 'tone',
      label: 'Tone',
      options: [
        { value: 'bold', label: 'Bold & Loud' },
        { value: 'premium', label: 'Premium & Minimal' },
        { value: 'playful', label: 'Playful & Fun' },
        { value: 'editorial', label: 'Editorial' },
        { value: 'tech', label: 'Tech / Futuristic' },
      ],
    },
    {
      key: 'platform',
      label: 'Platform',
      options: [
        { value: 'instagram', label: 'Instagram' },
        { value: 'tiktok', label: 'TikTok' },
        { value: 'facebook', label: 'Facebook' },
        { value: 'google', label: 'Google Ads' },
      ],
    },
    {
      key: 'style',
      label: 'Visual style',
      options: [
        { value: 'photo', label: 'Photoreal' },
        { value: 'cinematic', label: 'Cinematic' },
        { value: 'illustration', label: 'Illustration' },
        { value: '3d', label: '3D Render' },
        { value: 'graphic', label: 'Graphic / Typographic' },
      ],
    },
  ],

  'video-prompt': [
    {
      key: 'language',
      label: 'Language',
      options: [
        { value: 'english', label: 'English' },
        { value: 'spanish', label: 'Spanish' },
        { value: 'portuguese', label: 'Portuguese' },
        { value: 'french', label: 'French' },
        { value: 'german', label: 'German' },
      ],
    },
    {
      key: 'model',
      label: 'Target model',
      options: [
        { value: 'sora', label: 'Sora' },
        { value: 'veo', label: 'Veo 3' },
        { value: 'runway', label: 'Runway' },
        { value: 'kling', label: 'Kling' },
        { value: 'pika', label: 'Pika' },
      ],
    },
    {
      key: 'duration',
      label: 'Duration',
      options: [
        { value: '5s', label: '5 seconds' },
        { value: '10s', label: '10 seconds' },
        { value: '15s', label: '15 seconds' },
        { value: '30s', label: '30 seconds' },
      ],
    },
    {
      key: 'style',
      label: 'Style',
      options: [
        { value: 'cinematic', label: 'Cinematic' },
        { value: 'documentary', label: 'Documentary' },
        { value: 'anime', label: 'Anime' },
        { value: '3d', label: '3D Animation' },
        { value: 'hyperreal', label: 'Hyperreal' },
      ],
    },
    {
      key: 'mood',
      label: 'Mood',
      options: [
        { value: 'energetic', label: 'Energetic' },
        { value: 'calm', label: 'Calm' },
        { value: 'moody', label: 'Moody / Dark' },
        { value: 'bright', label: 'Bright & Happy' },
        { value: 'epic', label: 'Epic / Heroic' },
      ],
    },
  ],

  'marketing-plan': [
    {
      key: 'language',
      label: 'Language',
      options: [
        { value: 'english', label: 'English' },
        { value: 'spanish', label: 'Spanish' },
        { value: 'portuguese', label: 'Portuguese' },
        { value: 'french', label: 'French' },
      ],
    },
    {
      key: 'stage',
      label: 'Business stage',
      options: [
        { value: 'idea', label: 'Just an idea' },
        { value: 'pre-launch', label: 'Pre-launch' },
        { value: 'launched', label: 'Launched, getting first sales' },
        { value: 'scaling', label: 'Scaling already' },
      ],
    },
    {
      key: 'budget',
      label: 'Monthly marketing budget',
      options: [
        { value: '0-100', label: '$0 – $100' },
        { value: '100-500', label: '$100 – $500' },
        { value: '500-2000', label: '$500 – $2k' },
        { value: '2000-10000', label: '$2k – $10k' },
        { value: '10000+', label: '$10k+' },
      ],
    },
    {
      key: 'timeline',
      label: 'Timeline',
      options: [
        { value: '1m', label: '1 month' },
        { value: '3m', label: '3 months' },
        { value: '6m', label: '6 months' },
        { value: '12m', label: '12 months' },
      ],
    },
    {
      key: 'goal',
      label: 'Primary goal',
      options: [
        { value: 'sales', label: 'Direct sales' },
        { value: 'leads', label: 'Lead generation' },
        { value: 'awareness', label: 'Brand awareness' },
        { value: 'audience', label: 'Build an audience' },
      ],
    },
  ],

  'ad-copy': [
    {
      key: 'language',
      label: 'Language',
      options: [
        { value: 'english', label: 'English' },
        { value: 'spanish', label: 'Spanish' },
        { value: 'portuguese', label: 'Portuguese' },
        { value: 'french', label: 'French' },
        { value: 'german', label: 'German' },
        { value: 'italian', label: 'Italian' },
      ],
    },
    {
      key: 'platform',
      label: 'Platform',
      options: [
        { value: 'meta', label: 'Meta (FB/IG)' },
        { value: 'tiktok', label: 'TikTok Ads' },
        { value: 'google', label: 'Google Ads' },
        { value: 'youtube', label: 'YouTube Ads' },
        { value: 'email', label: 'Email' },
      ],
    },
    {
      key: 'tone',
      label: 'Tone',
      options: [
        { value: 'direct', label: 'Direct-response' },
        { value: 'story', label: 'Story-driven' },
        { value: 'luxury', label: 'Luxury / Premium' },
        { value: 'playful', label: 'Playful' },
        { value: 'authority', label: 'Authority / Expert' },
      ],
    },
    {
      key: 'goal',
      label: 'Campaign goal',
      options: [
        { value: 'sales', label: 'Sales / Purchase' },
        { value: 'leads', label: 'Leads' },
        { value: 'installs', label: 'App installs' },
        { value: 'awareness', label: 'Awareness' },
      ],
    },
  ],

  'niche-strategy': [
    {
      key: 'language',
      label: 'Language',
      options: [
        { value: 'english', label: 'English' },
        { value: 'spanish', label: 'Spanish' },
        { value: 'portuguese', label: 'Portuguese' },
        { value: 'french', label: 'French' },
      ],
    },
    {
      key: 'experience',
      label: 'Your experience',
      options: [
        { value: 'beginner', label: 'Beginner' },
        { value: 'intermediate', label: 'Intermediate' },
        { value: 'advanced', label: 'Advanced' },
      ],
    },
    {
      key: 'capital',
      label: 'Starting capital',
      options: [
        { value: '0', label: 'Zero budget' },
        { value: '0-100', label: '$0 – $100' },
        { value: '100-1000', label: '$100 – $1k' },
        { value: '1000+', label: '$1k+' },
      ],
    },
    {
      key: 'model',
      label: 'Preferred model',
      options: [
        { value: 'any', label: 'Open to anything' },
        { value: 'content', label: 'Faceless content' },
        { value: 'ecom', label: 'E-commerce' },
        { value: 'saas', label: 'Digital product / SaaS' },
        { value: 'service', label: 'Service / Agency' },
        { value: 'affiliate', label: 'Affiliate' },
      ],
    },
    {
      key: 'time',
      label: 'Time available / week',
      options: [
        { value: '<5h', label: 'Under 5h' },
        { value: '5-15h', label: '5 – 15h' },
        { value: '15-30h', label: '15 – 30h' },
        { value: 'fulltime', label: 'Full-time' },
      ],
    },
  ],

  'launch-strategy': [
    {
      key: 'language',
      label: 'Language',
      options: [
        { value: 'english', label: 'English' },
        { value: 'spanish', label: 'Spanish' },
        { value: 'portuguese', label: 'Portuguese' },
        { value: 'french', label: 'French' },
      ],
    },
    {
      key: 'window',
      label: 'Launch window',
      options: [
        { value: '7', label: '7 days' },
        { value: '14', label: '14 days' },
        { value: '30', label: '30 days' },
      ],
    },
    {
      key: 'intensity',
      label: 'Intensity',
      options: [
        { value: 'soft', label: 'Soft / Slow burn' },
        { value: 'medium', label: 'Medium' },
        { value: 'hardcore', label: 'Hardcore / All-in' },
      ],
    },
    {
      key: 'budget',
      label: 'Ad budget for the launch',
      options: [
        { value: '0', label: 'No paid ads' },
        { value: '100-500', label: '$100 – $500' },
        { value: '500-2000', label: '$500 – $2k' },
        { value: '2000-10000', label: '$2k – $10k' },
        { value: '10000+', label: '$10k+' },
      ],
    },
    {
      key: 'channels',
      label: 'Main channel',
      options: [
        { value: 'tiktok', label: 'TikTok' },
        { value: 'instagram', label: 'Instagram' },
        { value: 'youtube', label: 'YouTube' },
        { value: 'email', label: 'Email list' },
        { value: 'mixed', label: 'Mixed' },
      ],
    },
    {
      key: 'goal',
      label: 'Launch goal',
      options: [
        { value: 'revenue', label: 'Hit revenue target' },
        { value: 'signups', label: 'Maximize signups' },
        { value: 'waitlist', label: 'Build waitlist' },
        { value: 'audience', label: 'Grow audience' },
      ],
    },
  ],
};

export const getDefaultOptions = (toolId: string): Record<string, string> => {
  const fields = TOOL_OPTIONS[toolId] || [];
  const out: Record<string, string> = {};
  fields.forEach((f) => {
    out[f.key] = f.options[0].value;
  });
  return out;
};

export const formatOptionsAsText = (
  toolId: string,
  values: Record<string, string>,
): string => {
  const fields = TOOL_OPTIONS[toolId] || [];
  if (!fields.length) return '';
  const lines = fields
    .map((f) => {
      const v = values[f.key];
      const label = f.options.find((o) => o.value === v)?.label || v;
      return `- ${f.label}: ${label}`;
    })
    .join('\n');
  return `\n\n[USER PREFERENCES]\n${lines}\n[/USER PREFERENCES]`;
};
